import React, { createContext, useState } from 'react'
import { LanguageProvider } from './LanguageContext'

export const AppContext = createContext()

export const AppProvider = ({ children }) => {
  // Global state. You might keep user details, subscription status, theme, etc.
  const [isSubscribed, setIsSubscribed] = useState(false)

  const subscribeToService = () => {
    setIsSubscribed(true)
    // Additional logic for subscribing could go here
  }

  return (
    <AppContext.Provider value={{ isSubscribed, subscribeToService }}>
      <LanguageProvider>{children}</LanguageProvider>
    </AppContext.Provider>
  )
}
